import { Button, Card, Tag } from 'antd';
import React, { useState } from 'react'
import BlockHistoryPage from './ViewHistory.styles';
import styled from "styled-components";
import { CloseOutlined, UploadOutlined,EditOutlined } from '@ant-design/icons';
import Modal from '@iso/components/Feedback/Modal';
import { set } from 'lodash';
import AddActivityModal from './AddActivityModal';


const BlockActivityList = (props) => {

const [visibleDeleteActivity,setVisibleDeleteActivity] = useState(false);
const [activity,setActivity] = useState();
const [visibleActivity,setVisibleActivity] = useState(false);



  const onHandleDeleteActivity = (activity) => {
    setVisibleDeleteActivity(true);
    setActivity(activity.id);
  }
  const onHandleEditActivity = (activity) => {
    setActivity(activity);
    setVisibleActivity(true);
  } 

  const cancelModalActivity = () =>{
    setVisibleActivity(false);
  }
  
  const handleDeleteActivity = () =>{
    
  }

  const handleCancelActivity = () => {
    setVisibleDeleteActivity(false);
    setActivity();
  }
  return (
    <BlockHistoryPage>
     <div className="wrap-card-activity">
      <div className="wrap-btn-activity"> 
                  <Button type="link" className="btn-n-br btn-edit-activity" onClick={onHandleEditActivity.bind(this,activity)}>
                    <EditOutlined />
                  </Button>
                  <Button type="link" className="btn-n-br btn-delete-activity" onClick={onHandleDeleteActivity.bind(this, activity)}>
                    <CloseOutlined/>
                  </Button> 
                </div>
                </div>
    <Card bordered={true} title= "Plant" className="card-activity-title">
                {/* { activity.type === 'field_prep' && */}
                  <div>
                    <p><b>Block Name: </b>  Block </p>
                    <p><b> Start Time : </b> startTime</p>
                    <p><b> Finish Time: </b> FinishTime</p>
                    <p><b> Resource: </b> Resource Value</p>
                  </div>
                </Card>
    {
      props?.dataActivity?.map((activity, index) => { 
                  
        return(
            <div className="wrap-card-activity">

              <div className="wrap-btn-activity"> 
              <Button type="link" className="btn-n-br btn-edit-activity" onClick={onHandleEditActivity.bind(this,activity)}>
                    <EditOutlined />
                  </Button>
                  <Button type="link" className="btn-n-br btn-delete-activity" onClick={onHandleDeleteActivity.bind(this, activity)}>
                    <CloseOutlined/>
                  </Button> 
              </div>
              <Card title={activity.type.replace(/_/g, ' ')} bordered={true} className="card-activity-title">
                { activity.type === 'field_prep' &&
                  <div>
                  <p><b>Block Name: </b>  Block </p>
                    <p><b> Start Time : </b> startTime</p>
                    <p><b> Finish Time: </b> FinishTime</p>
                    <p><b> Resource: </b> Resource Value</p>
                    
                  </div>
                }    
                { activity.type === 'Plant' &&
                  <div>
                    <p><b> Name: </b> {''}</p>
                  </div>
                }    
                {activity.type === 'Picking' &&
                  <div>
                    <p> <b>Name: </b> {''}</p>
                  
                  </div>
                }
                {activity.type === 'Weeding' &&
                  <div>
                    <p> <b>Weeding: </b> {''}</p>
                  </div>
                }
                {activity.type === 'Spraying' &&
                  <div>
                    <p> <b>Spraying: </b> {''}</p>
                   
                  </div>
                }
                {activity.type === 'other' &&
                  <div>
                    <p> <b>other: </b> {''}</p>
                  </div>
                }  
              </Card>
            </div>
          )
     })
    }

      <AddActivityModal
        dataId = {props.dataId}
        visibleActivity = {visibleActivity}
        activity = {activity}
        cancelModalActivity = {cancelModalActivity}
        editActivity = 'true'
      />

    <DeleteActivityModal 
        className="modal-delete-activity" 
        title="Delete Activity" 
        visible={visibleDeleteActivity} 
        onOk={handleDeleteActivity} 
        onCancel={handleCancelActivity}>
        <p>Do you want to delete?</p>
      </DeleteActivityModal>
  </BlockHistoryPage>
 
  )
}
export default BlockActivityList;

const DeleteActivityModal = styled(Modal)`
  .ant-btn,.ant-btn:hover{
    color: #fff;
    border-color:#0000;
    background : #ABABAB;
  }  
  .ant-btn.ant-btn-primary,.ant-btn.ant-btn-primary:hover{
    background:#0B2A1B;
    color: #fff;
  }   
  
`;
